import i18n from 'shared/lib/i18n';

import {
  CALL_CENTER_DASHBOARD_LOADED,
  EE_BUILDING_SESSION_FAILURE,
  EE_BUILDING_SESSION_FINISHED,
  EE_BUILDING_SESSION_REQUESTED,
  EE_BUILDING_SESSION_SUCCEEDED,
  OPEN_DOOR,
  PERSONS_AND_UNITS_FAILURE,
  PERSONS_AND_UNITS_REQUEST,
  PERSONS_AND_UNITS_SUCCESS,
  SET_CALL_CENTER_MODAL_TYPE,
  SET_CURRENT_CAMERA_ID,
  SUBMIT_LEASING_MESSAGE_FAILURE,
  SUBMIT_LEASING_MESSAGE_REQUEST,
  SUBMIT_LEASING_MESSAGE_SUCCESS,
} from '../../actionConstants';
import { createDelivery } from '../Delivery/actions';

import { toSentenceCase } from '../../utils';
import { getRoleNames } from '../FrontDesk/utils';
import { getFullName } from '../Person/utils';

import apiClient from '../../apiClient';

export const openAccessPoint = (dispatch, accessPoint) =>
  dispatch({
    type: OPEN_DOOR,
    payload: apiClient.accessPoint.openAccessPoint(accessPoint),
    successMessage: i18n.t('popup.doorOpened', { doorName: accessPoint.name }),
  });

export const openAccessPointForVendor = (
  dispatch,
  accessPoint,
  data,
  callback,
) =>
  dispatch({
    type: OPEN_DOOR,
    payload: apiClient.accessPoint.openAccessPointForVendor(
      accessPoint?.id,
      data,
    ),
    successMessage: i18n.t('popup.doorOpened', { doorName: accessPoint.name }),
    callback: (res) => {
      res && callback && callback();
    },
  });

export const openAccessPointForVisitor = (dispatch, accessPoint, visitor) =>
  dispatch({
    type: OPEN_DOOR,
    payload: apiClient.accessPoint.openAccessPointForVisitor(
      accessPoint,
      visitor,
    ),
    successMessage: i18n.t('popup.doorOpened', { doorName: accessPoint.name }),
  });

export const openAccessPointForPerson = (dispatch, accessPoint, person) =>
  dispatch({
    type: OPEN_DOOR,
    payload: apiClient.accessPoint.openAccessPointForPerson(
      accessPoint,
      person,
    ),
    successMessage: i18n.t('popup.doorOpened', { doorName: accessPoint.name }),
  });

export const openAccessPointForDelivery = (dispatch, accessPoint, deliveryId) =>
  dispatch({
    type: OPEN_DOOR,
    payload: apiClient.accessPoint.openAccessPointForDelivery(
      accessPoint,
      deliveryId,
    ),
    successMessage: i18n.t('popup.doorOpened', { doorName: accessPoint.name }),
  });

export const openAccessPointForEmergency = (dispatch, accessPoint, data) =>
  dispatch({
    type: OPEN_DOOR,
    payload: apiClient.accessPoint.openAccessPointForEmergency(
      accessPoint,
      data,
    ),
    successMessage: i18n.t('popup.doorOpened', { doorName: accessPoint.name }),
  });

export const openDoor = (dispatch, door) =>
  dispatch({
    type: OPEN_DOOR,
    payload: apiClient.accessPoint.openDoor(door),
    successMessage: i18n.t('popup.doorOpened', { doorName: door.name }),
  });

export const openAccessPointForGeneralDelivery = (dispatch, accessPoint) =>
  dispatch({
    type: OPEN_DOOR,
    payload: apiClient.accessPoint.openAccessPoint(accessPoint),
    successMessage: i18n.t('popup.doorOpened', { doorName: accessPoint.name }),
  });

export const createGeneralDelivery = (dispatch, accessPoint, doors) => {
  const data = {
    building: accessPoint.building,
    accessPoint: accessPoint.id,
    isGeneralDelivery: true,
  };
  const defaultDoor = doors && doors.find((door) => door.defaultInBuilding);
  const callback = (res) => {
    if (!res) return null;
    defaultDoor && openDoor(dispatch, defaultDoor);
    openAccessPointForGeneralDelivery(dispatch, accessPoint);
    return null;
  };
  const successMessage = i18n.t('delivery.created');
  return createDelivery(dispatch, data, callback, successMessage);
};

export const setCallCenterModalType = (
  dispatch,
  modalType,
  defaultDeliveryType = null,
) =>
  dispatch({
    type: SET_CALL_CENTER_MODAL_TYPE,
    modalType,
    defaultDeliveryType,
  });

export const getEEBuildingSession = (dispatch, buildingId) =>
  dispatch({
    type: EE_BUILDING_SESSION_REQUESTED,
    payload: apiClient.building.eagleEyeSession(buildingId).then(
      (res) =>
        dispatch({
          type: EE_BUILDING_SESSION_SUCCEEDED,
          payload: res,
          buildingId,
        }),
      (err) =>
        dispatch({
          type: EE_BUILDING_SESSION_FAILURE,
          payload: err,
          buildingId,
        }),
    ),
  });

export const closeEESession = (dispatch) =>
  dispatch({
    type: EE_BUILDING_SESSION_FINISHED,
  });

export const loadCallCenter = (dispatch, phoneNumber) => {
  if (phoneNumber) {
    return dispatch({
      type: CALL_CENTER_DASHBOARD_LOADED,
      payload: apiClient.callCenter.get(phoneNumber).then((res) => {
        const buildingId = res?.data?.building?.id;
        buildingId && getEEBuildingSession(dispatch, buildingId);

        const sessionToken = res?.data?.callSessionToken;
        apiClient.setSessionToken(sessionToken);

        return res;
      }),
    });
  }
  return null;
};

const loadResidents = (dispatch, phoneNumber) =>
  dispatch({
    type: PERSONS_AND_UNITS_REQUEST,
    payload: apiClient.callCenter
      .loadResidents(phoneNumber)
      .then((res) =>
        dispatch({ type: PERSONS_AND_UNITS_SUCCESS, payload: res }),
      )
      .catch((err) => dispatch({ type: PERSONS_AND_UNITS_FAILURE, err })),
  });
const loadStaff = (dispatch, phoneNumber) =>
  dispatch({
    type: PERSONS_AND_UNITS_REQUEST,
    payload: apiClient.callCenter
      .loadStaff(phoneNumber)
      .then((res) =>
        dispatch({ type: PERSONS_AND_UNITS_SUCCESS, payload: res }),
      )
      .catch((err) => dispatch({ type: PERSONS_AND_UNITS_FAILURE, err })),
  });
const loadUnits = (dispatch, phoneNumber) =>
  dispatch({
    type: PERSONS_AND_UNITS_REQUEST,
    payload: apiClient.callCenter
      .loadUnits(phoneNumber)
      .then((res) =>
        dispatch({ type: PERSONS_AND_UNITS_SUCCESS, payload: res }),
      )
      .catch((err) => dispatch({ type: PERSONS_AND_UNITS_FAILURE, err })),
  });
const loadVisitors = (dispatch, phoneNumber) =>
  dispatch({
    type: PERSONS_AND_UNITS_REQUEST,
    payload: apiClient.callCenter
      .loadVisitors(phoneNumber)
      .then((res) =>
        dispatch({ type: PERSONS_AND_UNITS_SUCCESS, payload: res }),
      )
      .catch((err) => dispatch({ type: PERSONS_AND_UNITS_FAILURE, err })),
  });

export const loadPersonsAndUnits = (dispatch, phoneNumber) => {
  loadResidents(dispatch, phoneNumber);
  loadStaff(dispatch, phoneNumber);
  loadUnits(dispatch, phoneNumber);
  loadVisitors(dispatch, phoneNumber);
};

export const formatRecipients = (persons, isCallCenter, isFrontDesk) => {
  if (!persons) return [];
  return persons
    .map((person) => {
      const fullName = getFullName(person);
      const {
        id,
        residentRoles,
        boardMemberRoles,
        staffRoles,
        roles: callCenterOptions,
      } = person;

      if (isFrontDesk) return { label: fullName, value: id };

      const allRoles = [];

      Array.isArray(residentRoles) && allRoles.push(...residentRoles);
      Array.isArray(boardMemberRoles) && allRoles.push(...boardMemberRoles);
      Array.isArray(staffRoles) && allRoles.push(...staffRoles);

      // on the CC page only `roles` array is returned
      Array.isArray(callCenterOptions) && allRoles.push(...callCenterOptions);

      if (!allRoles.length) return null;

      const unitName =
        allRoles
          .filter(({ propertyLevel }) => propertyLevel !== 'building')
          .filter(({ propertyLevel }) => propertyLevel !== 'pmc')
          .map(({ propertyName }) => propertyName)
          .join(', ') || i18n.t('unit.noUnit');

      // on the CC page `roleName` is returned
      const roleName = isCallCenter
        ? [
            ...new Set(
              allRoles.map(({ roleName }) => toSentenceCase(roleName)),
            ),
          ].join(', ')
        : getRoleNames(allRoles.filter(({ role }) => role));

      return {
        label: `${fullName} | ${unitName} | ${roleName}`,
        value: id,
      };
    })
    .filter(Boolean);
};

export const submitLeasingMessage = (dispatch, buildingId, data) =>
  dispatch({
    type: SUBMIT_LEASING_MESSAGE_REQUEST,
    payload: apiClient.callCenter.submitLeasingMessage(buildingId, data).then(
      (res) =>
        dispatch({
          type: SUBMIT_LEASING_MESSAGE_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: SUBMIT_LEASING_MESSAGE_FAILURE,
          err,
        }),
    ),
  });

export const setCurrentCameraId = (dispatch, id) =>
  dispatch({ type: SET_CURRENT_CAMERA_ID, id });

export const getFullAddress = (data) => {
  const result = data
    ?.map((item, idx) => {
      if (item) {
        if (idx === data.length - 1) {
          return item;
        }
        return `${item},`;
      }
      return '';
    })
    .join(' ');
  return result;
};

export const getReasonOptions = () => [
  {
    name: i18n.t('callCenter.police'),
    id: 'Police',
  },
  {
    name: i18n.t('callCenter.fireDepartment'),
    id: 'Fire Department',
  },
  {
    name: i18n.t('common.other'),
    id: 'Other',
  },
];
